
import {app, authentication, dialog} from "@microsoft/teams-js"

export async function getAuthToken(): Promise<string> {
  return app.initialize().then(() => {
    return authentication.getAuthToken()
  }).catch(err => {
    console.error("Error getting auth token:", err)
    throw err
  })
}

export async function getContext(): Promise<app.Context> {
  await app.initialize()
  return app.getContext()
}

export async function submitTask(result: object): Promise<void> {
  await app.initialize()
  dialog.url.submit(result)
}
